import { render, staticRenderFns } from "./MSelectAddCat.vue?vue&type=template&id=da12062c&"
import script from "./MSelectAddCat.vue?vue&type=script&lang=ts&"
export * from "./MSelectAddCat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports